import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMetricsMeasurments = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", { d: "M11.291 11.2V3.852L5.625 7.526zM5.625 21.813 24 43.505l18.375-21.692zm36.75-2.583L31.1 12.795H16.9L5.625 19.23z" }),
		/* @__PURE__ */ _jsx("path", { d: "M10.979 6.525h26.042v2H10.979z" }),
		/* @__PURE__ */ _jsx("path", { d: "M36.709 3.852V11.2l5.666-3.674z" })
	] }) })
});
export default SvgMetricsMeasurments;
